import cn from 'classnames';
import { Fade } from 'transitions-kit';

import type { Flag } from '../../types';
import css from './flag.module.scss';
import { Select } from './select';
import { Switch } from './switch';
import { useFlag } from './use-flag';

interface Props {
    flag: Flag;
}
export function FeatureFlag({ flag }: Props) {
    const { value, isOverride, link } = useFlag(flag);
    const Control = typeof value === 'boolean' ? Switch : Select;

    return (
        <div className={css.flag}>
            <div>
                <a target="_blank" className={css.name} href={link}>
                    {flag.key}
                </a>

                <div className={css.tags}>
                    <span className={cn(css.tag, { [css.ab]: flag.isAbTest })}>
                        {flag.isAbTest ? '✦ A/B Test' : '❖ Targeted Delivery'}
                    </span>

                    <Fade in={isOverride}>
                        <span className={cn(css.tag, css.override)}>∅ override</span>
                    </Fade>
                </div>
            </div>

            <Control flag={flag} />
        </div>
    );
}
